export default __webpack_public_path__ + "static/media/fileWaterMarks.016e5ef0.svg";